export const SubscriptionEmpty = () => {
  return (
    <div className="rounded-2xl border-2 border-zinc-200 border-dashed p-10 text-center">
      <p className="font-medium text-zinc-900">No active subscription</p>
      <p className="mt-1 text-sm text-zinc-500">
        You don't have an active subscription yet.
      </p>
    </div>
  );
};
